/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Incident status
 */
export type IncidentStatus = (typeof IncidentStatus)[keyof typeof IncidentStatus];

export const IncidentStatus = {
  INPROGRESS: 'inProgress',
  NEW: 'new',
  RESOLVED: 'resolved',
  ARCHIVED: 'archived',
} as const;
